import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
// @ts-expect-error no types
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import RefreshLink from 'integrations-lib/components/RefreshLink';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import UILink from 'UIComponents/link/UILink';
import { ChirpErrorType, ErrorsType } from '../constants/commonConstants';
import { UserFacingMessageAlertWrapper } from '../styles/commonStyles';
import { isErrorWithoutMessageOutputToUser, errorLabels, getJSONObject, isIntegrationDisconnectedError, isThirdPartyOutageError, isChirpErrorWithMessageOutputToUser, parseApolloError, isChirpNotFoundError } from './errorUtils';
import { sanitizeHTML } from './sanitize';
import EmptyStateIllustration from '../components/EmptyStateIllustration';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const INTEGRATION_SETTINGS_NOT_FOUND_MESSAGE = 'Integration settings for specified app are not found.';
const buildFutureWebinarsNotFoundDefaultAlert = () => {
  return /*#__PURE__*/_jsxs(Alert, {
    type: "tip",
    children: [/*#__PURE__*/_jsx(View, {
      marginInlineStart: "800",
      marginBlockStart: "100",
      children: /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "videoConference.common.errorNotFoundUpcomingWebinarsMessage"
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      marginInlineStart: "800",
      marginBlockStart: "-300",
      children: /*#__PURE__*/_jsx(EmptyStateIllustration, {})
    })]
  });
};
const addSuccessFloatingAlert = (title, message) => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: title
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: message
    }),
    type: 'success'
  });
};
const buildAlertAtIntegrationDisconnected = (errorLabel, appName) => {
  return /*#__PURE__*/_jsx(Alert, {
    type: "danger",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: errorLabel.title,
      options: {
        appName
      }
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: errorLabel.message
    })
  });
};
const buildThirdPartyOutageAlert = (errorData, errorLabel, appName) => {
  return /*#__PURE__*/_jsx(Alert, {
    type: "danger",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: errorLabel.title,
      options: {
        appName
      }
    }),
    children: isErrorWithoutMessageOutputToUser(errorData) ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: errorLabel.message
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: errorData.message
    })
  });
};
export const buildFailAlert = (errorLabel, appName, style, isExternalLink) => {
  return /*#__PURE__*/_jsx("div", {
    style: Object.assign({}, style),
    children: /*#__PURE__*/_jsx(Alert, {
      type: "danger",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: errorLabel.title,
        options: {
          appName
        }
      }),
      children: errorLabel.link ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: errorLabel.message,
        elements: {
          Link: UILink
        },
        options: {
          href: errorLabel.link,
          target: '_blank',
          external: isExternalLink === undefined ? true : isExternalLink
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: errorLabel.message
      })
    })
  });
};

/**
 * @deprecated Use `buildFailAlert()` instead.
 */
const buildAlert = (errorLabel, appName, style, isExternalLink) => {
  return /*#__PURE__*/_jsx(Alert, {
    type: "danger",
    titleText: /*#__PURE__*/_jsx("div", {
      style: Object.assign({}, style),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: errorLabel.title,
        options: {
          appName
        }
      })
    }),
    children: errorLabel.link ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: errorLabel.message,
      elements: {
        Link: UILink
      },
      options: {
        href: errorLabel.link,
        target: '_blank',
        external: isExternalLink === undefined ? true : isExternalLink
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: errorLabel.message
    })
  });
};
const addFloatingAlertAtIntegrationDisconnected = (errorLabel, appName) => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: errorLabel.title
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: errorLabel.message,
      options: {
        appName
      }
    }),
    type: 'danger'
  });
};
const addFloatingAlert = (errorLabel, isRefreshLink, type = 'danger') => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: errorLabel.title
    }),
    message: isRefreshLink ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: errorLabel.message,
      elements: {
        RefreshLink
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: errorLabel.message
    }),
    type
  });
};

/**
 * @deprecated Use `buildContactSupportAlert()` instead.
 */
export const buildAlertWithContactSupport = (errorLabel, style, type = 'danger') => {
  return /*#__PURE__*/_jsx(Alert, {
    type: type,
    titleText: /*#__PURE__*/_jsx("div", {
      style: Object.assign({}, style),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: errorLabel.title
      })
    }),
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: errorLabel.message,
      elements: {
        RefreshLink,
        SupportLink: KnowledgeBaseButton
      },
      options: {
        supportLink: {
          url: 'https://help.hubspot.com/'
        }
      }
    })
  });
};
export const buildContactSupportAlert = (errorLabel, style, type = 'danger') => {
  return /*#__PURE__*/_jsx("div", {
    style: Object.assign({}, style),
    children: /*#__PURE__*/_jsx(Alert, {
      type: type,
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: errorLabel.title
      }),
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: errorLabel.message,
        elements: {
          RefreshLink,
          SupportLink: KnowledgeBaseButton
        },
        options: {
          supportLink: {
            url: 'https://help.hubspot.com/'
          }
        }
      })
    })
  });
};
export const buildFailureAlert = (errorLabel, type = 'danger') => {
  return buildAlertWithContactSupport(errorLabel, undefined, type);
};
export const addFailureFloatingAlert = (errorLabel, isRefreshLink = false) => {
  addFloatingAlert(errorLabel, isRefreshLink);
};
export const getGenericErrorAlert = () => {
  return buildAlertWithContactSupport(errorLabels[ErrorsType.GENERIC_ERROR]);
};
export const integrationSettingsFailureAlert = error => {
  const errorData = getJSONObject(error.data);
  if (!errorData) {
    return getGenericErrorAlert();
  }
  return errorData.message.trim() === INTEGRATION_SETTINGS_NOT_FOUND_MESSAGE ? buildFailureAlert(errorLabels[ErrorsType.INTEGRATION_SETTINGS_NOT_FOUND_ERROR]) : getGenericErrorAlert();
};
export const handleWebinarsAndUsersFailureAlert = (error, appName) => {
  const errorData = getJSONObject(error.data);
  if (!errorData) {
    return buildFailureAlert(errorLabels[error.errorType]);
  }
  if (isIntegrationDisconnectedError(errorData)) {
    return buildAlertAtIntegrationDisconnected(error.errorType === ErrorsType.GET_WEBINARS_ERROR ? errorLabels[ErrorsType.INTEGRATION_DISCONNECTED_FOR_WEBINARS_ERROR] : errorLabels[ErrorsType.INTEGRATION_DISCONNECTED_FOR_USERS_ERROR], appName);
  } else if (isThirdPartyOutageError(errorData)) {
    return buildThirdPartyOutageAlert(errorData, error.errorType === ErrorsType.GET_WEBINARS_ERROR ? errorLabels[ErrorsType.THIRD_PARTY_OUTAGE_FOR_WEBINARS_ERROR] : errorLabels[ErrorsType.THIRD_PARTY_OUTAGE_FOR_USERS_ERROR], appName);
  } else {
    return buildFailureAlert(errorLabels[error.errorType]);
  }
};
export const buildThirdPartyOutageFloatingAlert = (error, appName) => {
  const errorLabel = errorLabels[error.errorType];
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: errorLabel.title,
      options: {
        appName
      }
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: errorLabel.message
    }),
    type: 'danger'
  });
};
export const handleWebinarFailureFloatingAlert = (error, appName) => {
  const errorData = getJSONObject(error.data);
  if (!errorData) {
    if (error.errorType === ErrorsType.THIRD_PARTY_OUTAGE_FOR_WEBINARS_ERROR) {
      buildThirdPartyOutageFloatingAlert(error, appName);
    } else {
      addFailureFloatingAlert(errorLabels[error.errorType]);
    }
    return;
  }
  if (isIntegrationDisconnectedError(errorData)) {
    addFloatingAlertAtIntegrationDisconnected(errorLabels[error.errorType === ErrorsType.SAVE_WEBINAR_SETTINGS_ERROR ? ErrorsType.SAVE_WEBINAR_SETTINGS_AT_DISCONNECTED_STATUS_ERROR : ErrorsType.SYNC_WEBINAR_AT_DISCONNECTED_STATUS_ERROR], appName);
  } else {
    addFailureFloatingAlert(errorLabels[error.errorType]);
  }
};
export const saveUserSyncSettingsSuccessAlert = () => {
  addSuccessFloatingAlert('videoConference.alerts.globalSync.userSettings.savedSuccess.title', 'videoConference.alerts.globalSync.userSettings.savedSuccess.message');
};
export const buildAlertForWebinarForm = (errorLabel, appName, isExternalLink) => {
  return buildAlert(errorLabel, appName, {
    marginTop: '-15px'
  }, isExternalLink);
};
export const handleWebinarsFormFailureAlert = (error, appName) => {
  const style = {
    marginTop: '-15px'
  };
  const errorData = parseApolloError(error);
  if (!errorData) {
    return buildAlertWithContactSupport(errorLabels[ErrorsType.GET_WEBINARS_ERROR], style);
  }
  if (isChirpErrorWithMessageOutputToUser(errorData)) {
    const message = sanitizeHTML(errorData.errorMessage || '<p></p>');
    const isNotFoundError = isChirpNotFoundError(errorData);
    return /*#__PURE__*/_jsx(Alert, {
      type: isNotFoundError ? 'tip' : 'danger',
      children: /*#__PURE__*/_jsxs(UserFacingMessageAlertWrapper, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "text-without-indent",
          dangerouslySetInnerHTML: {
            __html: message
          }
        }), isNotFoundError && /*#__PURE__*/_jsx(EmptyStateIllustration, {})]
      })
    });
  }
  switch (errorData === null || errorData === void 0 ? void 0 : errorData.errorType) {
    case ChirpErrorType.THIRD_PARTY_OUTAGE_ERROR:
      return buildAlertForWebinarForm(errorLabels[ErrorsType.THIRD_PARTY_OUTAGE_FOR_WEBINARS_FORM_ERROR], appName);
    case ChirpErrorType.FORBIDDEN_ERROR:
      return buildAlertForWebinarForm(errorLabels[ErrorsType.WEBINAR_FORMS_PERMISSIONS_ERROR], appName, true);
    case ChirpErrorType.NOT_FOUND:
      return buildFutureWebinarsNotFoundDefaultAlert();
    default:
      return buildAlertWithContactSupport(errorLabels[ErrorsType.GET_WEBINARS_ERROR], style);
  }
};